/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled';
import { Column, Icon, Row } from '@ssmm/ui';
import { colors, HeadingH3, Text, TextBold } from 'components/landing/ui';
import { ArrowPrev } from 'components/landing/ui/controls';
import { arrowRight } from 'components/landing/ui/icons';

const titleText = { text1: 'Было', text2: 'Что сделал', text3: 'Стало' };

const Dot = styled('div')({
  width: 20,
  height: 20,
  marginRight: 30,
  borderRadius: '50%',
  border: `5px solid ${colors.blue}`,
  flexShrink: 0,
});

const Case = ({ target, onBackClick }) => {
  const { title, background } = target;

  return (
    <Column>
      <Row
        css={{
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: 30,
          textAlign: 'end',
        }}
      >
        <ArrowPrev onClick={onBackClick}>
          <Icon svg={arrowRight} />
        </ArrowPrev>

        <HeadingH3>
          Род деятельности: <span css={{ color: colors.blue }}>{title}</span>
        </HeadingH3>
      </Row>

      <div
        css={{
          backgroundImage: `url(${background[0]})`,
          borderRadius: 4,
          width: '100%',
          height: 254,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          filter: 'grayscale(1)',
          '@media (-webkit-min-device-pixel-ratio: 2)': {
            backgroundImage: `url(${background[1]})`,
          },
          '@media (-webkit-min-device-pixel-ratio: 3)': {
            backgroundImage: `url(${background[2]})`,
          },
        }}
      />

      {['text1', 'text2', 'text3'].map(k => (
        <div key={k} css={{ marginTop: 30 }}>
          <Dot />
          <div css={{ flexDirection: 'column', flexGrow: 1, flexShrink: 1 }}>
            <TextBold css={{ marginBottom: 10 }}>{titleText[k]}</TextBold>

            <Text css={{ color: colors.grayLight }}>{target[k]}</Text>
          </div>
        </div>
      ))}
    </Column>
  );
};

export default Case;
